<gtd-widgets-info-layout [isLoading]="isLoading" (onRefresh)="getData()">
  <p500-ui-cube-preloader *ngIf="isLoading"></p500-ui-cube-preloader>
  <div class="c-widget--info c-widget--info--white" *ngIf="!isLoading" [ngClass]="customClass">
    <ul>
      <li class="title" i18n="@@common.basic_information">Basic Information</li>
      <li>
        <p>
          <span class="key" i18n="@@common.country">Country:</span>
          <span class="value">
            <gtd-ui-field-default-country [data]="data.country_code"></gtd-ui-field-default-country>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.hash">Hash:</span>
          <span class="value">
            <gtd-ui-field-default-string-whitespace-or-empty-with-copy
              *ngIf="data?.hash; else noData"
              [data]="data?.hash"
              [length]="32"
              [fullWidth]="true"
              [className]="'d-flex'"
            >
            </gtd-ui-field-default-string-whitespace-or-empty-with-copy>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.offer">Offer:</span>
          <span class="value cut-overflow">
            <gtd-ui-field-default-link
              [link]="['/app/traffic-control/offers', data?.offer?.id]"
              [displayData]="data?.offer?.name"
              [relationData]="data?.offer?.id"
              [rbacProperty]="RbacPermissionsConstant.WIDGETS_OFFER_PROFILE"
            >
            </gtd-ui-field-default-link>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.brand">Brand:</span>
          <span class="value cut-overflow">
            <gtd-ui-field-default-link
              [link]="['/app/settings/crm-advertiser-brands', data?.advertiser_brand?.id]"
              [displayData]="data?.advertiser_brand?.name"
              [relationData]="data?.advertiser_brand?.id"
              [rbacProperty]="RbacPermissionsConstant.PAGES_TABLE_ADVERTISERS"
            >
            </gtd-ui-field-default-link>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.advertiser">Advertiser:</span>
          <span class="value cut-overflow">
            <gtd-ui-field-default-link
              [link]="['/app/advertisers/advertisers', data?.advertiser?.id]"
              [displayData]="data?.advertiser?.name"
              [relationData]="data?.advertiser?.id"
              [rbacProperty]="RbacPermissionsConstant.WIDGETS_ADVERTISER_PROFILE"
            >
            </gtd-ui-field-default-link>
          </span>
        </p>
      </li>
    </ul>
    <ul>
      <li class="title" i18n="@@common.affiliate_data">Affiliate Data</li>
      <li>
        <p>
          <span class="key" i18n="@@common.affiliate">Affiliate:</span>
          <span class="value cut-overflow">
            <gtd-ui-field-default-link
              [link]="['/app/affiliates/affiliates', data?.affiliate?.id]"
              [displayData]="data?.affiliate?.name"
              [relationData]="data?.affiliate?.id"
              [rbacProperty]="RbacPermissionsConstant.WIDGETS_AFFILIATE_PROFILE"
            >
            </gtd-ui-field-default-link>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Sub:</span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.aff_sub"></gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Sub 2:</span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.aff_sub2"></gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Sub 3:</span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.aff_sub3"></gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Sub 4:</span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.aff_sub4"></gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Sub 5:</span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.aff_sub5"></gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
    </ul>
    <ul>
      <li class="title">Additional</li>
      <li>
        <p>
          <span class="key">IP:</span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.ip"></gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.os">OS</span>: </span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.device_os"></gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.manufacturer">Manufacturer</span>: </span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.device_brand"></gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.model">Model</span>: </span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.device_model"></gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.user_agent">User Agent:</span>
          <span class="value">
            <gtd-ui-field-default-string-whitespace-or-empty-with-copy *ngIf="data?.user_agent; else noData" [data]="data?.user_agent">
            </gtd-ui-field-default-string-whitespace-or-empty-with-copy>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.created_at">Created At:</span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.created_at * 1000"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.updated_at">Updated At:</span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.updated_at * 1000"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
    </ul>
  </div>
</gtd-widgets-info-layout>

<ng-template #noData>
  <gtd-ui-field-default-string-or-empty></gtd-ui-field-default-string-or-empty>
</ng-template>
